import { render } from "./index.vue?vue&type=template&id=34bed9ac&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=34bed9ac&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-34bed9ac"

export default script